import { render, staticRenderFns } from "./SolidRingChat.vue?vue&type=template&id=3a4c73ad&scoped=true"
import script from "./SolidRingChat.vue?vue&type=script&lang=js"
export * from "./SolidRingChat.vue?vue&type=script&lang=js"
import style0 from "./SolidRingChat.vue?vue&type=style&index=0&id=3a4c73ad&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c73ad",
  null
  
)

export default component.exports